import "./adminEmptyState.css";

export const AdminEmptyState = ({ icon, title, description, action }) => (
  <div className="admin-empty-state">
    {icon && <div className="admin-empty-state__icon">{icon}</div>}
    {title && <h3 className="admin-empty-state__title">{title}</h3>}
    {description && <p className="admin-empty-state__description">{description}</p>}
    {action && <div className="admin-empty-state__action">{action}</div>}
  </div>
);
